/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import errorInterceptor from '@/services/api/interceptors/error';
import responseInterceptor from '@/services/api/interceptors/response';

const baseURL = process.env.VUE_APP_API_BASE;

const options = {
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  withCredentials: true,
};

const instance = axios.create(options);

instance.interceptors.response.use(responseInterceptor, errorInterceptor);

const createUrl = (endpoint, params) => {
  const url = new URL(`${baseURL}${endpoint}`);

  // handle arrays
  const getValue = value => (Array.isArray(value) ? value.join() : value);

  Object.entries(params)
    .forEach(([key, value]) => url.searchParams.append(key, getValue(value)));

  return url.toString();
};

export const createApiService = (endpoint, _instance = instance) => ({
  get: async (params = {}) => _instance.get(createUrl(endpoint, params)),
  getOne: async (id, params) => _instance.get(createUrl(`${endpoint}/${id}`, params)),
  create: async params => _instance.post(endpoint, params),
  update: async params => _instance.put(endpoint, params),
  delete: async id => _instance.delete(endpoint, id),
});

export default createApiService;
